import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SearchIcon from "@mui/icons-material/Search";
import ChatIcon from "@mui/icons-material/Chat";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import SchoolIcon from "@mui/icons-material/School";
import GroupIcon from "@mui/icons-material/Group";

import MuiSwitch from "../../components/mui-switch";
import SearchArea from "../../components/search-area";

import DrawerItem from "../drawer-item";
import Title from "./title";
import StyledDrawer from "./styles";
import NameMail from "./name-mail";
import ChatMenu from "./chat-menu";

const Drawer = ({
  onOpenClose,
  onSearchClick,
  onDrawerBlur,
  onSearchChange,
  onLogOutClick,
  onSearchIconClick,
  href,
  open,
  email,
  name,
  className,
  searcherPlaceHolder,
  onSearcherClick,
}) => {
  const navigate = useNavigate();

  const onClickChatHandler = () => {
    try {
      const lastChat = localStorage.getItem("ls");
      if (window.innerWidth > 776 && lastChat) {
        navigate(`/chat/${lastChat}`);
      } else {
        navigate("/chat");
      }
    } catch (e) {
      console.log(e);
      navigate("/chat");
    }
  };

  return (
    <StyledDrawer className={className}>
      <div className="drawer-container">
        <div className="drawer-content">
          <div className="menu-wrapper">
            <div className="main-menu">
              <div className="main-section">
                <DrawerItem
                  img={process.env.PUBLIC_URL + "/logo.png"}
                  link="/home"
                  active={false}
                  open={open}
                  leftComponent={<NameMail email={email} name={name} />}
                />

                <DrawerItem
                  Icon={SearchIcon}
                  active={
                    href.includes("/area-socios/search") ||
                    href.includes("/area-socios/grupos")
                  }
                  leftComponent={
                    <SearchArea
                      onClick={onSearcherClick}
                      onInputChange={onSearchChange}
                      placeholder={searcherPlaceHolder}
                    />
                  }
                  open={open}
                  onClick={onSearchIconClick}
                />
              </div>

              <div className="main-section">
                <DrawerItem
                  Icon={ChatIcon}
                  onClick={onClickChatHandler}
                  active={href.includes("/area-socios/chat")}
                  open={open}
                  leftComponent={<Title text="chats" />}
                />

                <DrawerItem
                  Icon={GroupIcon}
                  link="/search"
                  active={href.includes("/area-socios/search")}
                  open={open}
                  leftComponent={<Title text="usuarios" />}
                />
                <DrawerItem
                  Icon={SchoolIcon}
                  link="/grupos"
                  active={
                    href.includes("/area-socios/grupos") ||
                    href.includes("/area-socios/grupo")
                  }
                  open={open}
                  leftComponent={<Title text="grupos" />}
                />

                <DrawerItem
                  Icon={CalendarMonthIcon}
                  link="/calendar"
                  active={href.includes("/area-socios/calendar")}
                  open={open}
                  leftComponent={<Title text="calendario" />}
                />

                <DrawerItem
                  Icon={AccountCircleIcon}
                  link="/profile"
                  active={href.includes("/area-socios/profile")}
                  open={open}
                  leftComponent={<Title text="tu perfil" />}
                />
              </div>
            </div>
            <div className="option-section">
              <DrawerItem
                Icon={LogoutIcon}
                onClick={onLogOutClick}
                open={open}
                leftComponent={<Title text="LogOut" />}
              />
              {/* <MuiSwitch /> */}
            </div>
          </div>
          <ChatMenu />
        </div>
      </div>
    </StyledDrawer>
  );
};

export default Drawer;

// mobile -> 576px
